module.exports = __webpack_public_path__ + "img/valores.5f4af67b.png";